import Cruise from "../assets/cruise_.png";
import Bestprice from '../assets/bestprice_.png';
import Booking from '../assets/booking_.png';
import Zero from '../assets/zero_.png';
import Openworld from '../assets/explore.png';
import Easypay from '../assets/easypay.png';


const Wdata = [
    {
        img:Cruise,
        heading:"Cruising Pioneers"  ,
        para:"First to bring cruising to India, with 30+ years of experience"

    },
    {
        img:Bestprice,
        heading: "Best Price Guarantee" ,
        para:"We won't let you pay for more, when you book with us"

    },
    {
        img:Zero,
        heading: "Zero Service Charge" ,
        para:"We do not charge any additional fees or service charge, so you get our expertise for free"

    },
    {
        img: Openworld,
        heading:"We open up the World" ,
        para:"2/3rd of the world is covered with Water, so if you haven't cruised, you haven't seen the world!"

    },
    {
        img: Easypay,
        heading:"Convenient Payment"  ,
        para:"Pay by card, bank transfers, wallets, or EMIs for your next cruise vacation"

    },
    {
        img:Booking,
        heading: "Ease of Booking and Cancellation" ,
        para:"We let you book with a small booking amount and also offer you easy cancellation and refund policies, to suit your needs."

    }
]


export default Wdata ;